import { useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { logout } from '../api/auth';
import { useSession } from '../lib/session';

export function AppLayout() {
  const { me, setMe } = useSession();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const signOut = async () => {
    setBusy(true);
    let logoutUrl: string | undefined;
    try {
      logoutUrl = (await logout()).logout_url;
    } catch {
      setBusy(false);
    }
    if (logoutUrl) {
      window.location.assign(logoutUrl);
      return;
    }
    setMe(null);
    navigate('/login', { replace: true });
  };

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <header className="app-header">
        <div className="app-header-inner">
          <Link to="/" className="brand">
            <img src="/favicon.svg" alt="" />
            PresentationBuilder
          </Link>
          <Link to="/" className="small">
            Projects
          </Link>
          <div className="user-menu">
            {me ? (
              <span className="muted">
                {me.display_name} · {me.client_name}
              </span>
            ) : null}
            <Link to="/account" className="btn btn-sm btn-ghost">
              Account
            </Link>
            <button type="button" className="btn btn-sm" onClick={() => void signOut()} disabled={busy}>
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main id="main" className="app-main" tabIndex={-1}>
        <Outlet />
      </main>
    </>
  );
}
